import { ReactNode } from 'react';
import { cx } from './cx';
import { Text } from './Text';

export interface EmptyStateProps {
  /** A lucide icon (~22px) shown in a neutral featured-icon box. */
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Optional call to action (e.g. a Button). */
  action?: ReactNode;
  className?: string;
}

/**
 * Empty / zero state — an icon, title, supporting line and an optional action.
 * Replaces the ad-hoc "No X found" messages across catalog, approvals, etc.
 * An empty screen is an invitation to act.
 */
export const EmptyState = ({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) => (
  <div
    className={cx(
      'flex flex-col items-center gap-3 px-6 py-12 text-center',
      className,
    )}
  >
    {icon && (
      <span className="inline-flex size-11 items-center justify-center rounded-lg border border-default bg-surface text-fg-tertiary shadow-xs">
        {icon}
      </span>
    )}
    <div className="max-w-sm">
      <Text variant="body" className="font-semibold">
        {title}
      </Text>
      {description && (
        <Text variant="body" tone="tertiary" className="mt-1">
          {description}
        </Text>
      )}
    </div>
    {action && <div className="mt-1">{action}</div>}
  </div>
);
